import { Moment } from 'moment';
import { SchedulerReference } from 'components/organisms/resource-management/types';
import { useAllocationEventTooltip } from './allocation-event';
import { useAutoAllocateTooltip } from './auto-allocate';
import { useCommonEventTooltip } from './common-events';
import { usePlaceholderTooltip } from './placeholder';

export const useEventsTooltip = (
  ref: SchedulerReference,
  relativeDate: Moment,
  isHoursPerWeek: boolean,
): void => {
  useCommonEventTooltip(ref, relativeDate);
  useAllocationEventTooltip(ref, relativeDate, isHoursPerWeek);
  usePlaceholderTooltip(ref, relativeDate, isHoursPerWeek);
  useAutoAllocateTooltip(ref);
};
